import { SQLService } from '../../../services/sql.service';
import { ModalController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'ng-cheques-scan-administratior',
  templateUrl: './scan-administrator.component.html',
  styleUrls: ['./scan-administrator.component.styl']
})
export class ScanAdministratiorComponent implements OnInit {
  constructor(
    public sql: SQLService,
    private navCtrl: ModalController,
    private router: Router) {
  }
  list:string;
  end(e) {
    this.navCtrl.dismiss();
  }
  ngOnInit() {
  }
}